module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "lds-blocks",
    attrs: {
      "width": "200px",
      "height": "200px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('rect', {
    attrs: {
      "x": "19",
      "y": "19",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "19",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.125s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "61",
      "y": "19",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.25s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19",
      "y": "40",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.875s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "61",
      "y": "40",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.375s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19",
      "y": "61",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.75s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "61",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.625s",
      "calcMode": "discrete"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "61",
      "y": "61",
      "width": "20",
      "height": "20",
      "fill": "#1d3f72"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": "#5699d2;#1d3f72;#1d3f72",
      "keyTimes": "0;0.125;1",
      "dur": "1s",
      "repeatCount": "indefinite",
      "begin": "0.5s",
      "calcMode": "discrete"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b9423a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/Loader.vue
// module id = 505
// module chunks = 0